export default "__VITE_ASSET__50ba455f__"